import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { StpTabComponent } from '../stp-tab/stp-tab.component';
import { Payment } from './../../models/payment.model';
import { StpRegistrationStorageService } from './../../services/stp-registration-storage.service';
import { StpRegistrationService } from './../../services/stp-registration.service';
import { RequestData } from '../../models/stp_onlinePayment.model';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { environment } from 'src/environments/environment';
import { differenceInCalendarDays, setHours } from 'date-fns';
import { PaymentHistorySearch } from 'src/app/modules/payment/models/payment-history-search';
import { DatePipe, formatDate } from '@angular/common';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { PaymentStorageService } from 'src/app/modules/payment/services/payment-storage.service';
import { ServerResponse } from 'src/app/shared/models/dto/server-response.dto';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import FileSaver from 'file-saver';
import { applicationPermissions } from 'src/app/shared/application-constants/application-permissions';
@Component({
  selector: 'app-stp-payment',
  templateUrl: './stp-payment.component.html',
  styleUrls: ['./stp-payment.component.scss'],
})
export class StpPaymentComponent implements OnInit {
  paymentForm!: FormGroup;

  searchForm: FormGroup;
  paymentHistorySearch: PaymentHistorySearch;
  paymentHistoryResponse: any[] = [];
  paymentStatusList: { value: boolean; name: string }[] = [
    { value: true, name: 'Paid' },
    { value: false, name: 'Unpaid' },
  ];
  isPaymentVerified: boolean | null;
  isPaymentInfoFound: boolean = false;
  isPaymentCompleted: boolean;
  isSuccess: boolean;
  isCheckAndManagePaymentBtnClick: boolean = false;
  total: number;
  size: number = 10;
  page: number = 1;
  sortingKey: string;
  sortingValue: string;
  value: any = null;

  isEditMode!: boolean;
  payment!: Payment;
  requestData: RequestData = new RequestData();
  userInfo: any;
  transactionNumber: any;
  stpMainId: number;
  appSubmitData: any;
  notifyMsg: string;
  isPaymentExists = false;
  manualPayment = false;
  onlinePayment = false;
  isFileUpload = false;
  allowedExtensions = environment.validation.allowedPaymentExtensions;
  maxFormatFileSize = environment.validation.maxFileSize;
  @ViewChild('myInput')
  myInputVariable: ElementRef;
  today = new Date();
  timeDefaultValue = setHours(new Date(), 0);
  // file
  private userFile: any = File;

  applicationPermissions = applicationPermissions;

  constructor(
    private tab: StpTabComponent,
    private fb: FormBuilder,
    private msg: NzMessageService,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private stpRegistrationService: StpRegistrationService,
    private notification: NzNotificationService,
    private router: Router,
    private nzMessageService: NzMessageService,
    private utilityService: UtilityService,
    private route: ActivatedRoute,
    public paymentStorageService: PaymentStorageService,
    private ngxLoader: NgxUiLoaderService
  ) {}

  ngOnInit(): void {
    this.paymentForm = this.fb.group({
      amount: ['', [Validators.required, Validators.min(0)]],
      paymentDate: [''],
      bankName: ['', Validators.required],
      generationDate: [null],
      successDate: [null],
      isSuccess: [null],
      // paySlip: [null],
      transactionNo: [null],
      stpPaymentReasonId: [1],
      stpPaymentTypeId: [1],
    });

    this.requestData.id = this.route.snapshot.params.userId;
    if (!this.requestData.id) {
      this.constructRequestData();
    }

    this.onUserFullInformationRequest();
    this.createSearchForm();
    this.submitSearchForm();
  }

  range(start: number, end: number): number[] {
    const result: number[] = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }
  disabledDate = (current: Date): boolean =>
    // Can select days after today and today
    differenceInCalendarDays(current, this.today) > 0;

  // test Upload method
  onSelectFile(event: any): void {
    const message = this.utilityService.validateInputFile(
      event.target.files,
      this.allowedExtensions,
      this.maxFormatFileSize
    );
    if (message !== '') {
      this.notification.error('error', message);
      this.myInputVariable.nativeElement.value = '';
      return;
    }
    const file = event.target.files[0];
    this.userFile = file;
    this.isFileUpload = true;
  }
  // test method ends
  submitFormAndApply(): void {
    for (const i in this.paymentForm.controls) {
      if (this.paymentForm.controls.hasOwnProperty(i)) {
        this.paymentForm.controls[i].markAsDirty();
        this.paymentForm.controls[i].updateValueAndValidity();
      }
    }

    this.payment = this.paymentForm.value;
    const paymentInfo = this.paymentForm.value;
    const formData = new FormData();
    formData.append('payment', JSON.stringify(paymentInfo));
    formData.append('file', this.userFile);

    // method call
    if (this.stpRegistrationService.isStpMainAlreadyCreated) {
      if (this.isFileUpload) {
        this.stpRegistrationStorageService.savePaymentinfo(formData).subscribe({
          next: () => {
            {
              this.notification.success('Successful', 'Payment Successful');
              this.resetForm();
              // this.paymentForm.disable();
              this.constructRequestData();
              this.onUserFullInformationRequest();
              this.userFile = null;
            }
          },
          error: (error: any) => {
            this.notification.error(
              'Saving Failed',
              error.message === 'Server Error' ? error.details : error.message
            );
            // this.paymentForm.enable();
          },
        });
      } else {
        this.notification.error('Failed', 'Please upload file and try again.');
      }
    } else {
      this.notification.error('Failed', 'Please fill up basic profile first.');
    }
  }

  submitForm(): void {
    for (const i in this.paymentForm.controls) {
      if (this.paymentForm.controls.hasOwnProperty(i)) {
        this.paymentForm.controls[i].markAsDirty();
        this.paymentForm.controls[i].updateValueAndValidity();
      }
    }
  }
  // Online Payment Part

  // tslint:disable-next-line:typedef
  constructRequestData() {
    this.userInfo = JSON.parse(localStorage.getItem('currentUserInfo') || '{}');
    this.requestData.id = this.userInfo.id;
  }

  onSubmitPaymentRequest() {
  if (this.stpRegistrationService.isStpMainAlreadyCreated) {
    this.constructRequestData();
    this.stpRegistrationStorageService
      .initiatePaymentRequest(this.requestData)
      .subscribe((response) => {
        
        if (!response.success || !response.data) {
          this.notification.error('Failed', response.message || 'Payment link generation failed.');
          return; // ❗ STOP redirect
        }

        // ONLY redirect if success = true AND data is not null
        window.location.href = response.data;
      });
  } else {
    this.notification.error('Failed', 'Please fill up basic profile first.');
  }
}


  // tslint:disable-next-line:typedef
  onUserFullInformationRequest() {
    this.stpRegistrationStorageService
      .stpMainIdByUserId(this.requestData)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.stpMainId = res.data;
            this.getPaymentDetailsByStpMainId();
          }
        },
      });
  }

  // tslint:disable-next-line:typedef
  private getPaymentDetailsByStpMainId() {
    // @ts-ignore
    this.stpRegistrationStorageService
      .readPaymentDetailsByStpMainId(this.stpMainId)
      .subscribe(
        (res) => {
          if (res.data) {
            this.isPaymentCompleted = res.data?.isSuccess;
            this.isPaymentVerified = res.data?.isVerified;
            this.isPaymentExists = true;
            // this.notification.success(
            //   'Already Created!',
            //   'Basic Profile already created successfully'
            // );

            if (res?.data?.stpPaymentType?.id === 1) {
              this.paymentForm.disable();
              this.onlinePayment = true;
              this.transactionNumber = res?.data?.transactionNo;
            }
            if (res?.data?.stpPaymentType?.id === 2) {
              this.manualPayment = true;
            }
            this.paymentForm.patchValue({
              amount: res?.data?.amount,
              paymentDate: new Date(res?.data?.payDate),
              bankName: res?.data?.bankName,
            });
            // this.paymentForm.disable();
          }
        },
        (error) => {
          this.notification.error('Failed!', 'No payment details found!');
        }
      );
  }

  resetForm(): void {
    this.paymentForm.reset();
    this.isEditMode = false;
    for (const key of Object.keys(this.paymentForm.controls)) {
      this.paymentForm.controls[key].markAsPristine();
      this.paymentForm.controls[key].updateValueAndValidity();
    }
  }

  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  success(): void {
    this.router.navigate(['/home/stp-registration/success']);
  }

  nextPage(): void {
    this.tab.onclickButton();
  }
  previousPage(): void {
    this.tab.onclickButtonPrevious();
  }
  cancel(): void {
    this.nzMessageService.info('Feel free to update your information');
  }

  onApplyApplication() {
    this.notifyMsg = '';
    this.constructRequestData();
    this.stpRegistrationStorageService
      .isApplicationSubmitted(this.requestData.id)
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.appSubmitData = response.data;
            if (
              this.appSubmitData.initialSetup &&
              !this.appSubmitData.applicationSubmitted
            ) {
              if (this.appSubmitData.basicProfile) {
                if (this.appSubmitData.physicalInfrastructure) {
                  if (this.appSubmitData.trainer) {
                    if (this.appSubmitData.managementStaff) {
                      // financial details is not mandatory
                      // if (this.appSubmitData.financialDetails) {
                      if (this.appSubmitData.occupationSpecificTools) {
                        if (this.appSubmitData.furniture) {
                          if (this.appSubmitData.payment) {
                            this.router.navigate([
                              '/home/stp-registration/stp-application-view/' +
                                this.stpMainId,
                            ]);
                          } else {
                            this.notifyMsg = ' Payment Details';
                          }
                        } else {
                          this.notifyMsg = ' Furniture Details';
                        }
                      } else {
                        this.notifyMsg = ' Occupation Specific Tools ';
                      }
                      // } else {
                      //   this.notifyMsg = ' Financial Details ';
                      // }
                    } else {
                      this.notifyMsg = ' Management Staff Details ';
                    }
                  } else {
                    this.notifyMsg = ' Trainer Details ';
                  }
                } else {
                  this.notifyMsg = ' Physical Infrastructure ';
                }
              } else {
                this.notifyMsg = ' Basic Profile ';
              }
            } else {
              this.notifyMsg = ' Already submitted application ';
            }
            // this.notification.success('Success!','Furniture create successfully')
          }
        },
        error: (error) =>
          this.notification.error(
            'Failed',
            'Please! provide valid information'
          ),
      });
  }

  checkAndManagePayment() {
    this.isCheckAndManagePaymentBtnClick =
      !this.isCheckAndManagePaymentBtnClick;
  }

  createSearchForm() {
    this.searchForm = this.fb.group({
      transactionId: [null],
      paymentDate: [null],
      isSuccess: [null],
      historyFor: [null],
    });
  }

  //#region submit form
  submitSearchForm() {
    var pipe = new DatePipe('en-US');
    if (this.searchForm.controls.paymentDate.value) {
      const generalFromDateFormat = pipe.transform(
        this.searchForm.controls.paymentDate.value,
        'yyyy-MM-dd 00:00'
      );
      this.searchForm.controls.paymentDate.setValue(generalFromDateFormat);
    }
    this.paymentHistorySearch = this.searchForm.value;
    this.paymentHistorySearch.size = 10;
    this.paymentHistorySearch.page = 0;
    this.loadDataFromServer(this.paymentHistorySearch);
  }
  //#endregion

  onRefresh() {
    this.searchForm?.reset();
    this.loadDataFromServer(this.paymentHistorySearch);
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.page = params.pageIndex;
    this.size = params.pageSize;
    params.sort.forEach((element) => {
      if (element.value != null) {
        this.sortingKey = element.key;
        this.sortingValue = element.value;
      }
    });
    this.paymentHistorySearch.size = this.size;
    this.paymentHistorySearch.page = this.page - 1;
    this.paymentHistorySearch.sortingKey = this.sortingKey;
    this.paymentHistorySearch.sortingValue = this.sortingValue;
    this.loadDataFromServer(this.paymentHistorySearch);
  }

  loadDataFromServer(paymentHistorySearch: PaymentHistorySearch): void {
    const searchParams: PaymentHistorySearch = {
      ...paymentHistorySearch,
      historyFor: 'STP',
    };
    this.paymentStorageService.readPaymentHistory(searchParams).subscribe({
      next: (res: ServerResponse) => {
        if (res.success) {
          this.paymentHistoryResponse = res?.data?.content;
          this.isPaymentInfoFound = this.paymentHistoryResponse.length > 0;
          this.isSuccess = this.paymentHistoryResponse.some(
            (item) => item.applicationId && item.isSuccess === true
          );
          this.total = res.data?.totalElements;
          // this.notification.success('Success', res.message)
        } else {
          this.paymentHistoryResponse = [];
          this.total = 0;
          // this.notification.error('Failed', res.message);
        }
      },
      error: (error) => {
        this.notification.warning('Warning!!! ', 'No data found');
        this.paymentHistoryResponse = [];
        this.total = 0;
      },
    });
  }

  onDownloadJasperReport(transactionId: string) {
    this.ngxLoader.start();
    // Method to download a file
    const downloadFile = (reportData: string, fileName: string) => {
      if (reportData) {
        const binaryString = window.atob(reportData);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const fileType = 'application/pdf';

        const fileBlob = new Blob([bytes], { type: fileType });
        FileSaver.saveAs(fileBlob, fileName);
      }
    };

    // Method to handle downloading with file naming and error handling
    const handleReportDownload = (
      reportData: string | undefined,
      reportName: string
    ) => {
      if (reportData) {
        const fileName = `${reportName}.pdf`;
        downloadFile(reportData, fileName);
      } else {
        this.notification.error('Failed', `No ${reportName} data available`);
      }
    };

    this.paymentStorageService
      .paymentReceipt(transactionId, 'stp')
      .subscribe({
        next: (response) => {
          this.ngxLoader.stop();
          if (response.success) {
            handleReportDownload(response.data.report_one, 'E-Receipt');
            this.notification.success('Success', response.message);
          } else {
            this.notification.error('Failed', 'No report data available');
          }
        },
        error: (error) => {
          this.ngxLoader.stop();
          this.notification.error(
            'Failed',
            error?.message || 'An unexpected error occurred'
          );
        },
      });
    // } else {
    //   this.notification.error('Failed', 'Assessor ID not found');
    // }
  }

  onValidatePayment(
    id: number,
    applicationId: number,
    stpMainId: number,
    transactionId: string,
    paymentDate: string
  ): void {
    const formattedDate = formatDate(paymentDate, 'yyyy-MM-dd', 'en-US');
    const payload = {
      username: 'nsda_mer',
      trnx_id: transactionId,
      trans_date: formattedDate,
      // username: 'nsda_mer',
      // trnx_id: "5e00a74b-a6b0-4d7b-b7d5-bf5991f23baf",
      // trans_date: "2025-06-17",
    };

    this.paymentStorageService.readPaymentResponse(payload).subscribe({
      next: (res: ServerResponse) => {
        if (res.success) {
          const managePayload = {
            id: id,
            stpPaymentId: applicationId,
            stpMainId: stpMainId,
            paymentManageFor: 'STP',
            paymentJson: JSON.stringify(res.data),
          };

          this.paymentStorageService
            .manageCourseOrStpPayment(managePayload)
            .subscribe({
              next: (manageRes: ServerResponse) => {
                if (manageRes.success) {
                  this.notification.success(
                    'Payment managed successfully',
                    manageRes.message
                  );
                  this.onRefresh();
                  window.location.reload();
                } else {
                  this.notification.error(
                    'Failed to manage payment',
                    manageRes.message
                  );
                }
              },
              error: (err) => {
                this.notification.error('Error while managing payment', err);
              },
            });
        } else {
          this.notification.error('Payment validation failed', res.message);
        }
      },
      error: (err) => {
        this.notification.error('Error during payment validation', err);
      },
    });
  }
}
